import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { fetchWorkEntries } from "../../../../../store/slices/workentriesSlice";
import { fetchHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import OPShowTaskListPM from "./OPShowTaskListPM";
import FileUploadOP from "../../../Operationperson/FileUploadOP";
import DateConversion from "../../../../../utils/DateConversion";
const OPProjectapprovedPM = ({
    approvedOpProjectsState,
    handlerefresh,
    isViewOnly = false
}) => {
    const dispatch = useDispatch();
    const { formatDateByCountry } = DateConversion();

    const { employees } = useSelector((state) => state.employees);
    const { entries } = useSelector((state) => state.workentries);
    const { items } = useSelector((state) => state.hardwareDescription);
    const { tasks } = useSelector((state) => state.descriptionTasks);
    const { leads } = useSelector((state) => state.leads);
    const LoggedUser = localStorage.getItem("email");


    useEffect(() => {

        dispatch(fetchWorkEntries());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchDescriptionTasks());
        dispatch(fetchEmployees());
        dispatch(fetchLeads());

    }, [dispatch]);


    const [selected, setSelected] = useState(false);
    const responsereceiveddref = useRef(null);
    useEffect(() => {
        if ((selected)) {
            // Scroll to the right end of the container
            const scrollToPosition = responsereceiveddref.current.scrollWidth;
            responsereceiveddref.current.scrollTo({
                left: scrollToPosition,
                behavior: 'smooth'
            });
        }
    }, [selected]);

    const [loggedEmp, setLoggedEmp] = useState({})
    useEffect(() => {
        const loggedEmail = localStorage.getItem("email");
        const loggedEmp = employees.find(
            (person) => person.EmpEmail === loggedEmail
        );
        setLoggedEmp(loggedEmp)
    }, [employees])

    const [sortedProjects, setSortedProjects] = useState([]);

    useEffect(() => {
        setSortedProjects(approvedOpProjectsState);
    }, [approvedOpProjectsState])

    const itemsPerPage = 10; // or any number of rows you want per page
    const [currentPage, setCurrentPage] = useState(1);

    const [searchQuery, setSearchQuery] = useState("");

    const totalItems = sortedProjects?.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);

    console.log("hfgjfgj", paginatedProjects)
    const handleSearchInputChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        filterLeadReports(query);
        setCurrentPage(1);
    };

    const filterLeadReports = (query) => {
        const lowerCaseQuery = query.toLowerCase().trim();

        const filtered = approvedOpProjectsState.filter((LeadReport) =>
            Object.entries(LeadReport).some(([key, value]) => {
                // Skip these keys
                if (
                    key === "Assignedperson" ||
                    key === "TypeService" ||
                    key === "SalesPersonName" ||
                    key === "SalesPersonEmail" ||
                    key === "ResourceType" ||
                    key === "QuotedValue" ||
                    key === "ProjectManagerStatus" ||
                    key === "ProjectManagerAction" ||
                    key === "createdAt" ||
                    key === "updatedAt" ||
                    key === "PrimaryResources"
                )
                    return false;

                if (value === null || value === undefined) return false;
                if (key === "DateRequested" || key === "ProjectDueDate") {
                    const formattedDate = formatDateByCountry(value);  // ← change here
                    return formattedDate.toLowerCase().includes(lowerCaseQuery);
                }

                // Handle all other fields
                const formattedValue = value.toString().trim().toLowerCase();
                return formattedValue.includes(lowerCaseQuery);
            })
        );

        setSortedProjects(filtered);
    };

    // Replace your current sortAlphabetically function with this:
    const sortAlphabetically = (targetToSort, order) => {
        const key = `${targetToSort}-${order}`;
        let sorted = [...sortedProjects]; // Always sort from the filtered dataset

        const compareStrings = (a, b) => {
            const valA = (a || "").toString().toLowerCase();
            const valB = (b || "").toString().toLowerCase();
            return valA.localeCompare(valB);
        };
        // Helper function for date comparison
        const compareDates = (a, b) => {
            const dateA = a ? new Date(a) : null;
            const dateB = b ? new Date(b) : null;

            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            return dateA - dateB;
        };

        switch (key) {
            case "AssignedGroup-az":
                sorted.sort((a, b) => compareStrings(a.AssignedGroup, b.AssignedGroup));
                break;
            case "AssignedGroup-za":
                sorted.sort((a, b) => compareStrings(b.AssignedGroup, a.AssignedGroup));
                break;
            case "ProjectName-az":
                sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
                break;
            case "ProjectName-za":
                sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
                break;
            case "DateRequested-az":
                sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
                break;
            case "DateRequested-za":
                sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
                break;
            case "ProjectDueDate-az":
                sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
                break;
            case "ProjectDueDate-za":
                sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
                break;
            default:
                // Default to original filtered order
                sorted = [...sortedProjects];
                break;
        }

        setSortedProjects(sorted);
        setCurrentPage(1); // Reset to first page after sorting
    };


    const [showListState, setShowListState] = useState("tasktable");
    const [rowid, setrowid] = useState(null);


    const handleSalesAction = (row) => {
        const loggedEmail = localStorage.getItem("email");
        const loggedEmp = employees.find(
            (person) => person.EmpEmail === loggedEmail
        );

        if (!row?.Assignedperson?.length) return " ";

        // ✅ fixed missing parenthesis
        const matchedOP = row?.Assignedperson.find(
            (person) =>
                person.email === loggedEmp?.EmpEmail

        );

        if (!matchedOP) return " ";

        if (matchedOP.salespersonaction === "accept") return "Approved";
        if (matchedOP.operationaction === "in-progress") return "In Progress";
        if (matchedOP.operationaction === "cancelled") return "Cancelled";

        return " ";
    };

    // const handleleadread = async (row) => {
    //     const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    //     const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    //     const isUserAssigned = row.Assignedperson?.find(
    //         person => person.email === email // replace with your actual logged user email variable
    //     );
    //     const projectId = row._id
    //     const personId = currentEmployee._id

    //     if (isUserAssigned.isRead === false) {
    //         try {
    //             await dispatch(setPersonReadTrue({ projectId, personId }));
    //         } catch (error) {
    //             console.error("Error updating Notes:", error);
    //         } finally {
    //             handlerefresh()
    //         }
    //     }

    // };

    return (
        <div className="pt-2">
            <div className="bg-white">
                <div className="pt-2 flex justify-between items-center rounded-t p-2 bg-white">
                    <div className=" font-semibold">
                        <h3>Project Approved</h3>
                    </div>

                    <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                        <MdSearch className=" w-5 h-5 text-gray-500" />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search"
                            className="bg-[#e0e7ff] outline-none w-[80%]"
                        />
                    </div>
                </div>
                <div ref={responsereceiveddref} className="w-full overflow-auto bg-white h-full  min-h-[20vh] max-h-[90vh] ">
                    <div className=" sticky top-0 w-full">
                        <div className="flex w-full text-xs text-center text-white z-[50]">
                            <div className={`${rowid ? "w-full" : "w-[80%]"}`}>
                                <div className={` flex font-semibold`}>
                                    <div className="w-14 flex-shrink-0 bg-[#E8E8E8] text-black pl-3 h-12 border flex justify-start align-middle items-center">Sr. No</div>
                                    <div className={`${rowid ? "w-32 flex-shrink-0" : "w-[18.6%]"} relative h-12  bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-between align-middle items-center `}>
                                        <p className="text-start">Group</p>
                                        <div className="absolute right-2 flex flex-col">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("AssignedGroup", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("AssignedGroup", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-32 flex-shrink-0" : "w-[18.6%]"} relative h-12 bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-between align-middle items-center`}>
                                        Project
                                        <div className="absolute right-2 flex flex-col">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("ProjectName", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("ProjectName", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-36 flex-shrink-0" : "w-[19.6%]"} relative  h-12 bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-between align-middle items-center`}>
                                        <p className="text-start break-words whitespace-normal">Date Requested </p>
                                        <div className="absolute right-2 flex flex-col">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("DateRequested", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("DateRequested", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-32 flex-shrink-0" : "w-[19.6%]"} relative h-12 bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-between align-middle items-center`}>
                                        <p className="text-start break-words whitespace-normal"> Due Date </p>
                                        <div className="absolute right-2 flex flex-col">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("ProjectDueDate", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("ProjectDueDate", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-28 flex-shrink-0" : "w-[12.6%]"} h-12 bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                                        Attachments
                                    </div>
                                    <div className={`${rowid ? "w-28 flex-shrink-0" : "w-[20.6%]"} h-12 bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                                        Action
                                    </div>
                                </div>
                            </div>
                            {rowid ? (
                                <div className={`w-96 font-semibold h-12 flex-shrink-0 flex flex-col bg-[#E8E8E8] text-black break-words text-wrap`}>
                                    <div className="w-full p-1 h-[50%] break-words text-wrap flex justify-center items-center" >
                                        Total
                                    </div>
                                    <div className="w-full h-[50%] break-words text-wrap flex">
                                        <div
                                            onClick={() => setShowListState("tasktable")}
                                            className={`w-[50%] ${showListState === "tasktable" ? "bg-blue-500 text-white" : "text-black"} p-1.5 cursor-pointer flex justify-center items-center`}
                                        >
                                            Effort Expenses
                                        </div>
                                        <div
                                            onClick={() => setShowListState("otherexpenses")}
                                            className={` w-[50%] ${showListState === "otherexpenses" ? "bg-blue-500 text-white" : "text-black"} p-1. cursor-pointer flex justify-center items-center`}>
                                            Other Expenses
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className='flex w-[20%] h-12 font-semibold justify-center align-middle items-center bg-[#E8E8E8] text-black'>
                                    <h3> Task Details</h3>
                                </div>
                            )}
                        </div>

                        <div className="w-full">
                            {paginatedProjects?.map((row, index) => {
                                const matchedRowWorkEntries =
                                    entries.filter(
                                        (entry) => entry.projectid === row._id && entry.taskownerid === loggedEmp?._id
                                    );

                                const matchedRowDesctiption =
                                    tasks.filter(
                                        (entry) => entry.projectid === row._id && entry.taskownerid === loggedEmp?._id
                                    );


                                const matchedRowHardwareParts =
                                    items.filter(
                                        (entry) => entry.projectid === row._id && entry.taskownerid === loggedEmp?._id
                                    );
                                const isUserAssigned = row.Assignedperson?.find(
                                    person => person.email === LoggedUser // replace with your actual logged user email variable
                                );
                                return (
                                    <div
                                        className={`flex text-xs w-full ${isUserAssigned.isRead === false ? " font-bold" : ""} cursor-pointer  group hover:bg-gray-100`}
                                        key={index}
                                    >
                                        <div className={`flex ${rowid ? "w-full" : "w-[80%]"}`}>
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected);
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className="w-14 flex-shrink-0 border-b flex justify-start pl-3 align-middle items-center">{startIdx + index + 1}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected);
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className={` ${rowid ? "w-32 flex-shrink-0" : "w-[18.6%]"} border-b  flex justify-start align-middle items-center  p-2 break-words text-wrap`}>
                                                {row.AssignedGroup}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected);
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className={`${rowid ? "w-32 flex-shrink-0" : "w-[18.6%]"} border-b flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}>
                                                {row.ProjectName}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected);
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className={`${rowid ? "w-36 flex-shrink-0" : "w-[19.6%]"} border-b  flex justify-start align-middle items-center  p-2 break-words text-wrap`}>
                                                {row.DateRequested && !isNaN(new Date(row.DateRequested))
                                                    ? formatDateByCountry(row.DateRequested)
                                                    : ""}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected);
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className={`${rowid ? "w-32 flex-shrink-0" : "w-[19.6%]"} border-b flex justify-start align-middle items-center p-2 break-words text-wrap`}>
                                                {row.ProjectDueDate &&
                                                    !isNaN(new Date(row.ProjectDueDate))
                                                    ? formatDateByCountry(row.ProjectDueDate)
                                                    : ""}
                                            </div>
                                            <div className={`${rowid ? "w-28 flex-shrink-0" : "w-[12.6%]"} border-b p-1 text-center flex justify-center align-middle items-center break-words text-wrap`}>
                                                <FileUploadOP project={row} leads={leads} employees={employees} isViewOnly={isViewOnly} />
                                            </div>
                                            <div className={`${rowid ? "w-28 flex-shrink-0" : "w-[20.6%]"}  border-b p-2 text-center flex justify-center align-middle items-center break-words text-wrap`}>
                                                {handleSalesAction(row)}
                                            </div>
                                        </div>

                                        {rowid === row.ProjectName ? (
                                            <div className={` w-96 flex-shrink-0 p-2 border-b`}>
                                                <OPShowTaskListPM
                                                    row={row}
                                                    showListState={showListState}
                                                    matchedRowWorkEntries={matchedRowWorkEntries}
                                                    matchedRowHardwareParts={matchedRowHardwareParts}
                                                    matchedRowDesctiption={matchedRowDesctiption}
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => {
                                                    // const isOpening = rowid !== row.ProjectName;
                                                    setrowid(prev => prev === row.ProjectName ? null : row.ProjectName)
                                                    setSelected(!selected)
                                                    // if (isOpening) {
                                                    //     handleleadread(row)
                                                    // }
                                                }}
                                                className={` ${rowid ? "" : "w-[20%]"} border-b cursor-pointer flex justify-center align-middle items-center`}>
                                                {rowid ? (
                                                    <div className='flex group-hover:bg-gray-100'>
                                                        <div className="w-96 border-b p-2 py-4 break-words text-wrap flex justify-center align-middle items-center ">
                                                            Multiple
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="w-full text-center">
                                                        Multiple
                                                    </div>

                                                )}
                                            </div>
                                        )}

                                    </div>
                                )
                            })}
                            {paginatedProjects?.length === 0 && (
                                <div className="noDataAvailable p-2">No Result Found</div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={`pagination mt-2 flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects?.length > 0 ? "p-1" : ""
                        } `}
                >
                    <div>
                        {totalItems > 0 ? (
                            <>
                                Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                                {totalItems} Entries
                            </>
                        ) : (
                            <>
                                {paginatedProjects?.length > 0 && (
                                    <>Showing {paginatedProjects?.length} Entries</>
                                )}
                            </>
                        )}
                    </div>


                    {totalPages > 1 && (
                        <div className="flex">
                            <button
                                onClick={() => setCurrentPage(1)}
                                className="px-2 py-2 mx-1 border rounded"
                                disabled={currentPage === 1}
                                title="First Page"
                            >
                                <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                            </button>
                            <button
                                onClick={() =>
                                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                                }
                                className="px-2 py-2 mx-2 border rounded"
                                disabled={currentPage === 1}
                            >
                                <ChevronRightIcon className="w-5 h-5 rotate-180" />
                            </button>

                            {Array.from({ length: 3 }, (_, index) => {
                                const pageNumber = currentPage - 1 + index;
                                if (pageNumber >= 1 && pageNumber <= totalPages) {
                                    return (
                                        <button
                                            key={pageNumber}
                                            onClick={() => setCurrentPage(pageNumber)}
                                            className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                                ? "bg-gray-300"
                                                : ""
                                                }`}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                }
                                return null;
                            })}

                            <button
                                onClick={() =>
                                    setCurrentPage((prev) =>
                                        Math.min(prev + 1, totalPages)
                                    )
                                }
                                className="px-2 py-2 mx-2 border rounded"
                                disabled={currentPage === totalPages}
                            >
                                <ChevronRightIcon className="w-5 h-5" />
                            </button>

                            <button
                                onClick={() => setCurrentPage(totalPages)}
                                className="px-2 py-2 mx-1 border rounded"
                                disabled={currentPage === totalPages}
                                title="Last Page"
                            >
                                <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div >
    )
}

export default OPProjectapprovedPM